import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import role from 'role';

export default function RootTermList({ match }) {
    
    const fields = [
        { name: 'Id', key: 'id' },
        { name: 'Root Term Type', keys: ['rootTermType', 'termTypeName'] },
        { name: 'Root Term Name', key: 'rootTermName' },
    ];

    return (
        <ListCRUD
            plural='rootTerms'
            singular='rootTerm'
            fields={fields}
            match={match}
            canEdit={[role.ADMIN, role.NATIONAL_AUTHORITY]}
            canNew={[role.ADMIN, role.NATIONAL_AUTHORITY]}
        />
    );
}